module.exports = __webpack_public_path__ + "static/media/embs_blanc.518cc866.png";